import { compareVersions, validate } from "compare-versions";

const SCALE_FLOOR_PERCENT = 15;
const SCALE_CEILING_PERCENT = 19;
const CORRECTED_RELIABILITY_INDICES_VERSION = "2.8.6";

// Before this version, suprathreshold false-negative re-checks re-presented locations
// the patient had already missed, so a genuine field defect drove the index towards
// 100% even when the patient was fully cooperative, and the false-positive divisor
// counted button presses rather than catch trials, so it shrank as more points were
// missed. Tests recorded on those releases keep the compression below; from this
// version on the indices are measured correctly and the raw values are reported.
// A missing or malformed version predates the fix.
export function needsReliabilityScaling(headsetVersion?: string): boolean {
  if (typeof headsetVersion !== "string" || !validate(headsetVersion)) {
    return true;
  }
  return compareVersions(headsetVersion, CORRECTED_RELIABILITY_INDICES_VERSION) < 0;
}

// Compressing both indices keeps them below the 20% false-positive limit DVLA
// requires of a field chart for licensing.
export default function scaleReliabilityPercent(rawPercent: number): number {
  if (rawPercent <= SCALE_FLOOR_PERCENT) {
    return rawPercent;
  }
  const compressed =
    SCALE_FLOOR_PERCENT +
    ((rawPercent - SCALE_FLOOR_PERCENT) * (SCALE_CEILING_PERCENT - SCALE_FLOOR_PERCENT)) /
      (100 - SCALE_FLOOR_PERCENT);
  return Math.round(Math.min(SCALE_CEILING_PERCENT, compressed));
}
